module.exports = __webpack_public_path__ + "assets/img/honor.649bdb95.png";